import { BlockBasic } from "../_models/models.js"

export default class BlockTemplate extends BlockBasic {
  constructor(block) {
    super(block)
    this.type = "template"
    this.data = {}
  }
}
